module.exports = __webpack_public_path__ + "img/bg-img-white3.79f7da47.png";